import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { qmsService } from '../qms.service';
import * as moment from 'moment';

@Component({
  selector: 'app-task-stage-statistics',
  templateUrl: './task-stage-statistics.component.html',
  styleUrls: ['./task-stage-statistics.component.scss']
})
export class TaskStageStatisticsComponent implements OnInit {

  taskStageList: any = [];
  constructor(private readonly appService: AppService, private readonly qualityService: qmsService) { }

  ngOnInit() {
    this.taskStageList = []
    let data = {
      taskNo: this.qualityService.activityId,
      module: this.qualityService.moduleName,
    };
    this.appService.getTaskStage(data).subscribe((data1: any) => {
      this.taskStageList = data1;
      for (let s = 0; s < this.taskStageList.length; s++) {
        if (this.taskStageList[s].minDate != null && this.taskStageList[s].maxDate != null) {
          this.taskStageList[s].stage = "Passed";
        }
        if (this.taskStageList[s].minDate == null && this.taskStageList[s].maxDate == null && this.taskStageList[s].isCurrentStage == "N") {
          this.taskStageList[s].stage = "Pending";
        }
        if (this.taskStageList[s].isCurrentStage == "Y") {
          this.taskStageList[s].stage = "Current";
        }

        if (s == (this.taskStageList.length - 1)) {
          if ((this.taskStageList[s].stage != "Current") && (this.taskStageList[s].stageName == 'Deleted' || this.taskStageList[s].stageName == 'Deleted/Obsoleted')) {
            this.taskStageList = this.taskStageList.filter((item: { stageName: string; }) => (item.stageName !== 'Deleted'));
            this.taskStageList = this.taskStageList.filter((item: { stageName: string; }) => (item.stageName !== 'Deleted/Obsoleted'));
          }
        }
      }
    });
  }

  tooltipText: any;
  getToolTip(value: any) {
    let tempMax = value.maxDate == null ? null : new Date(value.maxDate);
    let tempMin = value.minDate == null ? null : new Date(value.minDate);
    let maxDate = "";
    let minDate = "";
    this.tooltipText = "";

    if (tempMax) maxDate = this.getDate(tempMax);
    if (tempMin) minDate = this.getDate(tempMin);

    if (minDate != "") this.tooltipText += "Started On : " + minDate + " \n";
    if (maxDate != "") this.tooltipText += "Ended On  : " + maxDate + ' ';
  }

  getDate(value: Date) {
    let htmlDateFormat = this.appService.organizationDetails?.htmlDateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.htmlDateFormat.toUpperCase();
    let date3 = moment(value).format(htmlDateFormat);

    const hr = String(value.getHours()).padStart(2, "0");
    const mn = String(value.getMinutes()).padStart(2, "0");
    const ss = String(value.getSeconds()).padStart(2, "0");

    return `${date3} ${hr}:${mn}:${ss}`;
  }

  getColumnSizes(value: any) {
    return 'repeat(' + value.length + ', 1fr) ';
  }
}
